"use strict";

import angular from "angular";

const name = "infiniteScrollOnDemand";
const factory = [
    "$timeout",
    ($timeout) => ({
        restrict: "A",
        scope: {
            fn: "&infiniteScrollOnDemand"
        },
        link: ($scope, $elem, $attr) => {
            if (!$attr.infiniteScrollOnDemand) return;
            const expressionHandler = $scope.fn();
            const elem = angular.element($elem[0]);
            elem.on("scroll", () => {
                const { clientHeight, scrollHeight, scrollTop } = elem[0];
                $timeout(() => {
                    if (scrollTop + clientHeight >= scrollHeight) {
                        expressionHandler(elem[0]);
                    }
                }, 100);
            });
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
